import { all, put, takeEvery } from "redux-saga/effects";
import { fetcher, getErrorMsg, handleError } from "lib/fetch";
import * as actions from "./actions";

const url = "slumps"

function* loadSlumps(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(url, params, token);
    yield put(actions.loadSlumps.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.loadSlumps.failure(getErrorMsg(error)));
  }
}

function* showSlump(action) {
  try {
    const { id, token } = action.payload;
    const res = yield fetcher.get(`${url}/${id}`, token);
    yield put(actions.showSlump.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.showSlump.failure(getErrorMsg(error)));
  }
}

function* createSlump(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(`${url}/create`, params, token);
    yield put(actions.createSlump.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.createSlump.failure(getErrorMsg(error)));
  }
}

function* updateSlump(action) {
  try {
    const { params, id, token } = action.payload;
    const res = yield fetcher.post(`${url}/update/${id}`, params, token);
    yield put(actions.updateSlump.success(res.data));
   
  } catch (error) {
    handleError(error);
    yield put(actions.updateSlump.failure(getErrorMsg(error)));
  }
}

function* deleteSlump(action) {
  try {
    const { id, token } = action.payload;
    yield fetcher.get(`${url}/delete/${id}`, token);
    yield put(actions.deleteSlump.success(id));
  } catch (error) {
    handleError(error);
    yield put(actions.deleteSlump.failure(getErrorMsg(error)));
  }
}

function* importSlump(action) {
  try {
    const { file, token } = action.payload;
    const formData = new FormData();
    formData.append("file_name", file.originFileObj);
    const res = yield fetcher.upload(`${url}/import`, formData, token);
    yield put(actions.importSlump.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.importSlump.failure(getErrorMsg(error)));
  }
}

function* exportSlump(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(`${url}/export`, params, token);
    yield put(actions.exportSlump.success(res.data));
    fetcher.download(res.data.data);
  } catch (error) {
    handleError(error);
    yield put(actions.exportSlump.failure(getErrorMsg(error)));
  }
}

export default function* watchSlump() {
  yield all([
    takeEvery(actions.LOAD_SLUMP.REQUEST, loadSlumps),
    takeEvery(actions.SHOW_SLUMP.REQUEST, showSlump),
    takeEvery(actions.CREATE_SLUMP.REQUEST, createSlump),
    takeEvery(actions.UPDATE_SLUMP.REQUEST, updateSlump),
    takeEvery(actions.DELETE_SLUMP.REQUEST, deleteSlump),
    takeEvery(actions.IMPORT_SLUMP.REQUEST, importSlump),
    takeEvery(actions.EXPORT_SLUMP.REQUEST, exportSlump),
  ]);
}
